import React, { useEffect } from 'react';
import { Toaster } from 'sonner';
import { TopBar } from './components/sections/TopBar';
import { Hero } from './components/sections/Hero';
import { StatsStrip } from './components/sections/StatsStrip';
import { SocialProofTop } from './components/sections/SocialProofTop';
import { Problems } from './components/sections/Problems';
import { EmotionalTransition } from './components/sections/EmotionalTransition';
import { ProductIntro } from './components/sections/ProductIntro';
import { WhatsIncluded } from './components/sections/WhatsIncluded';
import { InsideGallery } from './components/sections/InsideGallery';
import { EverythingYouGet } from './components/sections/EverythingYouGet';
import { Bonuses } from './components/sections/Bonuses';
import { ForWho } from './components/sections/ForWho';
import { Comparison } from './components/sections/Comparison';
import { Urgency } from './components/sections/Urgency';
import { Offer } from './components/sections/Offer';
import { Testimonials } from './components/sections/Testimonials';
import { Guarantee } from './components/sections/Guarantee';
import { TrustBar } from './components/sections/TrustBar';
import { Faq } from './components/sections/Faq';
import { SecondUrgency } from './components/sections/SecondUrgency';
import { FinalCta } from './components/sections/FinalCta';
import { Footer } from './components/sections/Footer';
import { PurchasePopup } from './components/PurchasePopup';
import { META_PIXEL_ID } from './utils/constants';
declare global {
  interface Window {
    fbq?: ((...args: unknown[]) => void) & {
      callMethod?: (...args: unknown[]) => void;
      queue?: unknown[];
    };
    _fbq?: unknown;
  }
}
export function App() {
  useEffect(() => {
    try {
      if (!window.fbq) {
        const fbq: any = function (...args: unknown[]) {
          if (fbq.callMethod) {
            fbq.callMethod.apply(fbq, args);
          } else {
            fbq.queue.push(args);
          }
        };
        fbq.push = fbq;
        fbq.loaded = true;
        fbq.version = '2.0';
        fbq.queue = [];
        window.fbq = fbq;
        window._fbq = fbq;
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        document.head.appendChild(script);
      }
      window.fbq?.('init', META_PIXEL_ID);
      window.fbq?.('track', 'PageView');
    } catch {
      /* el pixel no debe romper la página */
    }
  }, []);
  return <div className="w-full min-h-screen bg-crema text-tinta font-sans" data-id="element-0" data-mp="3bmjq7ep1tau0">
      <TopBar data-id="element-1" data-mp="3bk72ekwm0691" />
      <main data-id="element-2" data-mp="3qb7klhn5reid">
        <Hero data-id="element-3" data-mp="3qaxuzv60z9d7" />
        <StatsStrip data-id="element-4" data-mp="3qbfud0nzi3pc" />
        <SocialProofTop data-id="element-5" data-mp="3qbzd2jlgkw4f" />
        <Problems data-id="element-6" data-mp="3qdajysa7ajzr" />
        <EmotionalTransition data-id="element-7" data-mp="3lkhfm5in9do7" />
        <ProductIntro data-id="element-8" data-mp="3lk7pmhxln6ii" />
        <WhatsIncluded data-id="element-9" data-mp="3liwl2fwbxuqc" />
        <InsideGallery data-id="element-10" data-mp="3limryjfzn7gf" />
        <EverythingYouGet data-id="element-11" data-mp="2xun3jq65ft50" />
        <Bonuses data-id="element-12" data-mp="2xtv76d4q9rdo" />
        <ForWho data-id="element-13" data-mp="2xtc0jskj2pey" />
        <Comparison data-id="element-14" data-mp="2xsseq0rrbgvn" />
        <Urgency data-id="element-15" data-mp="2svtnbpzh9o15" />
        <Offer data-id="element-16" data-mp="2swbu3gjrnknb" />
        <Testimonials data-id="element-17" data-mp="2suqzxs1d63pz" />
        <Guarantee data-id="element-18" data-mp="2svjw5z2p5atv" />
        <TrustBar data-id="element-19" data-mp="2stzcx5lu1ebb" />
        <Faq data-id="element-20" data-mp="18e1axny9tulm" />
        <SecondUrgency data-id="element-21" data-mp="18d9haio8i6xz" />
        <FinalCta data-id="element-22" data-mp="18cznek02jfn0" />
      </main>
      <Footer data-id="element-23" data-mp="18bolyqu3ijz2" />
      <Toaster position="bottom-left" data-id="element-24" data-mp="1d4hor9607i8i" />
      <PurchasePopup data-id="element-25" data-mp="1d5j9k5ctnj3f" />
    </div>;
}